import type { VideoJob } from '../services/local-video';

/** Capture text and its bar use the same measured frame ratio. */
export function videoJobProgress(job: Pick<VideoJob, 'phase' | 'progress' | 'frameProgress'>): number {
  const frames = job.frameProgress;
  if (job.phase === 'capture' && frames && frames.total > 0) {
    return Math.max(0, Math.min(100, Math.floor(frames.captured * 100 / frames.total)));
  }
  return job.progress;
}
